import CustomButton from 'components/customButton';
import FormikInput from 'components/formikFields/input';
import FormikSelect from 'components/formikFields/select';
import {Form, Formik} from 'formik';

import {
  CitiesToOption,
  ProvincesToOption,
} from 'utilities/helper/provinceToOption';

import {useAuth} from 'context/authContext';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';

import {useState} from 'react';
import useEditProfile from './hooks/useEditProfile';
import UploadImage from './UploadImage';
import {account_types} from './utilities';
import {AddSchema} from './utilities/schema';

interface IEditProfile {
  name: string;
  state: string;
  city: string;
  account_type: string;
}
const EditProfile = () => {
  const {user} = useAuth();
  const {provinces} = UseGetProvince();
  const {editProfile, isLoading} = useEditProfile();
  const [image, setImage] = useState<Array<IUploadImage>>([]);

  const initialValues: IEditProfile = {
    name: user?.profile?.name || '',
    city: user?.profile?.city ? user?.profile?.city.toString() || '' : '',
    state: user?.profile?.state ? user?.profile?.state.toString() || '' : '',
    account_type: user?.profile?.account_type || '',
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={AddSchema}
      enableReinitialize
      onSubmit={values => {
        const payload: IUpdateProfilePayload = {
          account_type: values?.account_type,
          city: values.city,
          state: values.state,
          guid: user?.profile?.guid || '',
          name: values?.name,
          ...(image[0] && {profile_image: image[0]?.file}),
        };

        editProfile(payload);
      }}
    >
      {({values}) => {
        values && console.log(values);
        return (
          <Form noValidate className="mt-[100px] w-full  mb-[120px]">
            <div className="w-full px-4">
              <div className="flex justify-center w-full mt-3">
                <UploadImage images={image} setImages={setImage} />
              </div>
              <div className="flex flex-col items-center justify-center w-full py-4 mb-6">
                <p className="font-normal text-[18px] leading-[24px] text-gray-6 text-start">
                  {user?.profile?.name}
                </p>
                <span className="text-gray-5 font-normal text-[18px] leading-[24px] text-start">
                  {user?.profile?.phone_number}
                </span>
              </div>
              <div className="mt-4">
                <FormikInput name="name" label="نام و  نام خانوادگی" required />
              </div>
              <div className="mt-4">
                <FormikSelect
                  name="state"
                  label="استان"
                  Options={ProvincesToOption(provinces || [])}
                  required
                />
              </div>
              <div className="mt-4">
                <FormikSelect
                  name="city"
                  label="شهر"
                  Options={CitiesToOption(
                    provinces?.find(x => x.id === Number(values.state))
                      ?.cities || [],
                  )}
                  disabled={!values.state}
                />
              </div>
              <div className="mt-4">
                <FormikSelect
                  name="account_type"
                  label="نقش کاربری"
                  Options={account_types}
                  required
                />
              </div>
              <div className="mt-4">
                <CustomButton
                  type="submit"
                  title="ذخیره"
                  isLoading={isLoading}
                />
              </div>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default EditProfile;
